 require('../modal');require('./basket');
riot.tag2('popup-basket', '<yield></yield> <modal name="basketmodal" bssize="lg" onclose="{opts.onclose || true}" title="Your Basket" onsave="{checkout}" savetext="Proceed to Checkout"> <basket riot-src="{parent.opts.src}" language="{parent.opts.language}" currency="{parent.currency || parent.opts.currency}" showvat="{parent.opts.showvat}"></basket> <select show="{parent.opts.showcurrency}" onchange="{parent.updateCurrency}" value="{parent.currency || parent.opts.currency}" class="form-control popup-basket-currency"> <option value="GBP">£ (GBP)</option> <option value="USD">$ (USD)</option> <option value="EUR">€ (EUR)</option> </select> </modal>', '@media (min-width: 400px) { .form-control.popup-basket-currency { position: absolute; bottom: -51px; left: 15px; width: auto; } }', 'onclick="{updateBasket}"', function(opts) {
var tagSelector;

this.currency = null;

tagSelector = require('../../utils/tagSelector.coffee');

this.on('mount', function() {
  this.basket = tagSelector('basket', 'popup-basket');
  return this.root.trigger = this.trigger;
});

this.on('updateBasket', function() {
  return this.updateBasket();
});

this.checkout = (function(_this) {
  return function() {
    return window.location.href = opts.checkoutUrl || "/checkout/";
  };
})(this);

this.updateCurrency = (function(_this) {
  return function(e) {
    _this.update({
      currency: e.target.value
    });
    return _this.basket.trigger('updateBasket');
  };
})(this);

this.updateBasket = (function(_this) {
  return function() {
    _this.tags.basketmodal.show();
    _this.tags.basketmodal.tags.basket.trigger('updateBasket');
    return _this.update();
  };
})(this);
});